export default __webpack_public_path__ + "static/button-label-dont-dark-8b1900334eb1ffa39d98e9bc561e14db5f77cc4bce0695e027aa82469e44ef26.png";